module.exports = __webpack_public_path__ + "static/media/ResearchConnect_3.98dacba5.jpg";